var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","label":_vm.$t('downtime.type'),"return-object":"","item-text":"name","items":_vm.typeList,"prepend-inner-icon":"mdi-text-box-multiple-outline"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})
}
var staticRenderFns = []

export { render, staticRenderFns }